import { StyledTimePicker } from './TimePicker.styled'

const TimePicker = ({ ...props }) => {
  return <StyledTimePicker {...props} />
}

export default TimePicker
